import { withDevtools } from '@angular-architects/ngrx-toolkit';
import { inject, Signal } from '@angular/core';
import { GetPartnerNameByMpnIdRequest } from '@models/csp/csp-util.model';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { catchError, EMPTY, pipe, switchMap, tap } from 'rxjs';
import { CspUtilService } from './csp-util.service';

type CspUtilState = {
  retrievedPartnerNameFromMicrosoft: string | null;
  isPartnerNameRetrievalFromMicrosoftLoading: boolean;
};

const initialState: CspUtilState = {
  retrievedPartnerNameFromMicrosoft: null,
  isPartnerNameRetrievalFromMicrosoftLoading: false,
};

export const CspUtilStore = signalStore(
  withState(initialState),
  withDevtools('csp-util-store'),
  withMethods((store, cspUtilService = inject(CspUtilService)) => ({
    getPartnerNameByMpnId: rxMethod<{ req: GetPartnerNameByMpnIdRequest }>(
      pipe(
        tap(() => patchState(store, { retrievedPartnerNameFromMicrosoft: null, isPartnerNameRetrievalFromMicrosoftLoading: true })),
        switchMap(({ req }) =>
          cspUtilService.getPartnerNameByMpnId(req).pipe(
            tap(response => {
              patchState(store, {
                retrievedPartnerNameFromMicrosoft: response.name,
                isPartnerNameRetrievalFromMicrosoftLoading: false,
              });
            }),
            catchError(() => {
              patchState(store, { retrievedPartnerNameFromMicrosoft: null, isPartnerNameRetrievalFromMicrosoftLoading: false });
              return EMPTY;
            }),
          ),
        ),
      ),
    ),
    reset: () => {
      patchState(store, initialState);
    },
  })),
);

export interface CspUtilStoreType {
  readonly retrievedPartnerNameFromMicrosoft: Signal<string | null>;
  readonly isPartnerNameRetrievalFromMicrosoftLoading: Signal<boolean>;

  readonly getPartnerNameByMpnId: (input: { req: GetPartnerNameByMpnIdRequest }) => void;
  readonly reset: () => void;
}
